import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
//api
import { createAuthor, editAuthor } from 'api/products';
//helpers
import { verificateNullValue } from 'helpers';
//components
import Input from 'components/backoffice/customInput/index';
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import FooterModal from 'components/backoffice/modals/FooterModal';

const AutorModal = ({
  type = 'edit',
  object = {},
  show,
  setShow,
  onUpdateTable
}) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  useEffect(() => {
    if (show) {
      if (type === 'create') {
        setTitle(t('createauthor'));
        setName('');
      } else {
        setTitle(t('edit', { title: object?.nombre_autor }));
        setName(verificateNullValue(object?.nombre_autor));
      }
    }
  }, [show, type, object, setTitle]);

  const onSuccess = () => {
    setName('');
    setShow(false);
    onUpdateTable();
  };

  const onCreate = useCallback(async () => {
    try {
      const { data, status } = await createAuthor({ nombre_autor: name });

      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        onSuccess();
      } else if (status === 400) {
        toast.error(t('thereAlreadyAuthorName'));
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
     
    } catch (error) {
      console.error('Error en onCreate author:', error);
      toast.error(t('errorCreatingAuthor'));
    }
  }, [name, onSuccess]);

  const onUpdate = useCallback(async () => {
    try {
      const { status } = await editAuthor({ nombre_autor: name }, object.id);

      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        onSuccess();
      } else if (status === 400) {
        toast.error(t('thereAlreadyAuthorName'));
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.error('Error en onUpdate author:', error);
    }
  },[name, object, onSuccess]);

  const handleSave = useCallback(async () => {
    setLoading(true);
    setErrors({});
    if (!name) {
      setErrors({ nombre_autor: [t('camporequerido')] });
      setLoading(false);
      return;
    }
    if (type === 'create') {
      onCreate();
    } else {
      onUpdate();
    }
    setLoading(false);
  },[name, onCreate, onUpdate, type]);

  const handleClose = () => {
    setShow(false)
    setTitle(t('autores'))
  }
  
  useEffect(() => {
    setErrors({});
  }, [name]);

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title={t(type === 'create' ? 'createauthor' : 'editauthor')}
      footer={<FooterModal onCancel={handleClose} onSave={handleSave} loading={loading} />}
    >
      <Input
        placeholder={t('name')}
        value={name}
        onChange={setName}
        error={errors?.nombre_autor && errors?.nombre_autor[0]}
        label={t('name')}
      />

    </ModalCustom>
  );
};

AutorModal.prototype = {
  type: PropTypes.oneOf(['create', 'edit']).isRequired,
  object: PropTypes.object,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  onUpdateTable: PropTypes.func.isRequired,
};

export default AutorModal;
